import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getAdjacentQuestions } from "modules/diagnostic/diagnostic-selectors";
import { getLocale } from "modules/i18n/locale-selectors";
import { getQuestionFormName } from "modules/diagnostic/diagnostic-utils";
import DiagnosticActions from "modules/diagnostic/diagnostic-actions";
import QuestionFormAnimated from "modules/general-info/question-form-animated";
import { getLocaleSpecificProp } from "modules/i18n/locale-utils";
import ProgressBar from "modules/general-info/progress-bar";

import { QuestionKeys } from "modules/diagnostic/diagnostic-constants";

class QuestionSet extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onPrevious: PropTypes.func.isRequired,
    adjacentQuestions: PropTypes.shape({
      previous: PropTypes.object,
      current: PropTypes.object,
      next: PropTypes.object
    })
  };

  // QUESTION WITH VIDEO EXAMPLE JSON
  // {
  //   "id": 405,
  //   "key": "q_test_functional_single_wrist_test_q1",
  //   "step": 60,
  //   "content_type": "functionalTest",
  //   "files": {
  //     "image": [],
  //     "en": {
  //       "video": {
  //         "id": 118,
  //         "title": "T16-2 Vid",
  //         "name": "T16-2 Vid",
  //         "extension": "mp4",
  //         "link_url": "https://s3.eu-central-1.amazonaws.com/heal.prod.public/diagnostics/files/T16-2%20Vid.mp4",
  //         "type": "video",
  //         "function_type": "functionalTest",
  //         "description": "Wrist",
  //         "properties": {
  //           "size": 0
  //         },
  //         "created_at": 1523716413,
  //         "updated_at": 1523716417
  //       }
  //     }
  //   },
  //   "test_poster_id": null,
  //   "question": {
  //     "en": "Play the video and perform the test.\n\nHow many times could you lift your pain free or less painful hand?",
  //     "swe": "Hur många gånger kunde du lyfta din friska eller mindre smärtande hand?"
  //   },
  //   "answer": {
  //     "max": 5,
  //     "min": 0,
  //     "type": "single",
  //     "subtype": "range"
  //   },
  //   "properties": [],
  //   "description": ""
  // }

  getVideoURL = (question, locale) => {
    if (!question || !question.files) {
      return null;
    }

    const localeSpecificVideo = getLocaleSpecificProp(question.files, locale);

    if (
      !localeSpecificVideo ||
      !localeSpecificVideo.video ||
      !localeSpecificVideo.video.link_url
    ) {
      return null;
    }

    // To test out just return "https://s3.eu-central-1.amazonaws.com/heal.prod.public/diagnostics/files/T16-2%20Vid.mp4";
    return localeSpecificVideo.video.link_url;
  };

  render() {
    const {
      adjacentQuestions: { previous, current, next },
      locale,
      onPrevious,
      onNext,
      onChange
    } = this.props;
    if (!current) {
      return null;
    }
    //prevent progress bar to jump over the human body icon
    const shouldLockBody =
      (!next ||
        next.key !== QuestionKeys.PAIN_VAS ||
        next.key !== QuestionKeys.PAIN_TYPE) &&
      current.key === QuestionKeys.HUMAN_MODEL;

    const { selectedAnswer } = current;
    const videoURL = this.getVideoURL(current, locale);
    return (
      <Fragment>
        <ProgressBar shouldLockBody={shouldLockBody} />
        <QuestionFormAnimated
          key={current.id}
          form={getQuestionFormName(current.id)}
          hasPrevious={Boolean(previous)}
          previous={
            previous ? getLocaleSpecificProp(previous.question, locale) : ""
          }
          next={next ? getLocaleSpecificProp(next.question, locale) : ""}
          onNext={onNext}
          onPrevious={onPrevious}
          onChange={onChange}
          locale={locale}
          question={current}
          destroyOnUnmount={false}
          enableReinitialize
          initialValues={
            (selectedAnswer !== undefined && {
              answer:
                typeof selectedAnswer === "object"
                  ? selectedAnswer.map(item => `${item}`)
                  : `${selectedAnswer}`
            }) ||
            undefined
          }
          videoURL={videoURL}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  adjacentQuestions: getAdjacentQuestions(state),
  locale: getLocale(state)
});

const mapDispatchToProps = {
  onChange: DiagnosticActions.Creators.onChangeAnswer,
  onNext: DiagnosticActions.Creators.moveToNextQuestion,
  onPrevious: DiagnosticActions.Creators.moveToPreviousQuestion
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionSet);



// WEBPACK FOOTER //
// ./src/modules/general-info/question-set.js